//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { TrackingIdPrefix } from '@models/TrackingId';

export const UIA_BULK_ACTIONS_TRACKING_ID_PREFIX: TrackingIdPrefix =
  'uia-bulk-actions-';

export const UiaBulkActionsTrackingIds = {
  ADD_TO_STREAM_MODAL_CANCEL: `${UIA_BULK_ACTIONS_TRACKING_ID_PREFIX}add-to-stream-modal-cancel`,
  ADD_TO_STREAM_MODAL_SUBMIT: `${UIA_BULK_ACTIONS_TRACKING_ID_PREFIX}add-to-stream-modal-submit`,
  CANCEL_DELETE_FROM_LIBRARY: `${UIA_BULK_ACTIONS_TRACKING_ID_PREFIX}cancel-delete-from-library`,
  DELETE_FROM_LIBRARY_CONFIRMATION: `${UIA_BULK_ACTIONS_TRACKING_ID_PREFIX}delete-from-library-confirmation`,
  MODERATOR_CANCEL: `${UIA_BULK_ACTIONS_TRACKING_ID_PREFIX}moderator-cancel`,
  MODERATOR_CONFIRM: `${UIA_BULK_ACTIONS_TRACKING_ID_PREFIX}moderator-confirm`,
  MODERATOR_DOWNLOAD: `${UIA_BULK_ACTIONS_TRACKING_ID_PREFIX}moderator-download`,
  MODERATOR_MORE: `${UIA_BULK_ACTIONS_TRACKING_ID_PREFIX}moderator-more`,
  MODERATOR_REMOVE: `${UIA_BULK_ACTIONS_TRACKING_ID_PREFIX}moderator-remove`,
  MODERATOR_REQUEST_REVIEW: `${UIA_BULK_ACTIONS_TRACKING_ID_PREFIX}moderator-request-review`,
  MODERATOR_SHARE: `${UIA_BULK_ACTIONS_TRACKING_ID_PREFIX}moderator-share`,
};
